import { cn } from "@/lib/utils";
import { ClassAttributes, HTMLAttributes } from "react";

import { IconBox } from "./IconBox";
import { Text } from "./Text";

type ChipProps = ClassAttributes<HTMLDivElement> &
    HTMLAttributes<HTMLDivElement> & {
        className?: string;
        variant?: "default" | "variant2" | "variant3";
    };

export const Chip = ({
    variant = "default",
    children,
    className,
    ...props
}: ChipProps) => {
    const variantClasses = {
        default: {
            container: "",
            icon: "text-white bg-primary-main pl-0.5",
            text: "text-white bg-subcolor-background-black p-1"
        },
        variant2: {
            container: "",
            icon: "text-white bg-subcolor-orange pl-0.5",
            text: "text-white bg-subcolor-background-black py-1 px-medium"
        },
        variant3: {
            container: "",
            icon: "text-primary-main bg-transparent pl-0",
            text: "text-primary-main bg-transparent py-1 px-0"
        }
    }[variant];

    return (
        <div
            className={cn(
                "flex h-6 w-max items-center overflow-hidden rounded-[10px]",
                className
            )}
            {...props}
        >
            <div
                className={cn(
                    "flex h-full items-center justify-center",
                    variantClasses.icon
                )}
            >
                <IconBox
                    name="Original_small"
                    size="medium"
                    color="text-white"
                />
            </div>
            <Text className={cn(variantClasses.text, "px-2")} variant="caption2">
                {children}
            </Text>
        </div>
    );
};
